import 'react-hot-loader/patch';
import {AppContainer} from 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import {platform} from 'onsenui';

import {Provider} from 'react-redux';
import {createStore, applyMiddleware} from 'redux';

import ChatApp from './reducers/index';
import App from './app';
import Loader from './loader';
import {addMessages} from "./actions/chat-body";
import {initApp, initProtocol} from './actions/chat-root';
import isBrowser from './utils/isBrowser';

const store = createStore(ChatApp,
  window.devToolsExtension ? window.devToolsExtension() : f => f,
  process.env.NODE_ENV === 'production'
    ? applyMiddleware(thunk)
    : applyMiddleware(thunk, logger)
);

// ReactDOM.render(
//   <AppContainer>
//     <Provider store={store}>
//       <Loader />
//     </Provider>
//   </AppContainer>,
//   rootElement
// );
//
// if (module.hot) {
//   module.hot.accept('./loader', () => {
//     const NextApp = require('./loader').default;
//     ReactDOM.render(
//       <AppContainer>
//         <Provider store={store}>
//           <NextApp />
//         </Provider>
//       </AppContainer>,
//       rootElement
//     );
//   });
// }

function render(rootElement) {

  if(platform.isIPad()) {
    rootElement.classList.add('cu-ui-chat-large');
  }

  if (window != undefined || isBrowser()) {
    if (window.innerWidth > 600) {
      rootElement.classList.add('cu-ui-chat-large');
    }

    window.onresize = function () {
      if (window.innerWidth > 600) {
        rootElement.classList.add('cu-ui-chat-large');
      } else {
        rootElement.classList.remove('cu-ui-chat-large');
      }
    }
  }

  // google ana
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments)
    }, i[r].l = 1 * new Date();
    a = s.createElement(o),
      m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m)
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

  ga('create', 'UA-104949268-1', 'auto');
  ga('send', 'pageview');

  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <App />
      </Provider>
    </AppContainer>,
    rootElement
  );

  if (module.hot) {
    module.hot.accept('./app', () => {
      const NextApp = require('./app').default;
      ReactDOM.render(
        <AppContainer>
          <Provider store={store}>
            <NextApp />
          </Provider>
        </AppContainer>,
        rootElement
      );
    });
  }
}

window.cu_web_plugin = {
  initApp: function (element, {
    title: title,
    debugFunc: debugFunc,
    fullFunc: fullFunc,
    closeFunc: closeFunc
  }) {
    store.dispatch(initApp({
      title: title,
      debugFunc: debugFunc,
      fullFunc: fullFunc,
      closeFunc: closeFunc
    }));
    render(element);
  },
  initProtocol: function (custom_functions) {
    store.dispatch(initProtocol(custom_functions))
  },
  loadData: function (messages) {
    store.dispatch(addMessages(messages))
  },
  passsiveReceiver: function (message) {
    store.dispatch(addMessages([message]))
  }
};



// WEBPACK FOOTER //
// ./src/index.jsx